import React from "react";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Banner1 from "../../images/slider1.jpg";

const Banner = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: { xs: "500px", md: "600px", lg: "650px" },
        backgroundImage: `url(${Banner1})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Optional overlay for better text contrast */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.15)",
          zIndex: 1,
        }}
      />

      {/* Decorative elements */}
      <Box
        sx={{
          position: "absolute",
          top: "20px",
          left: "50px",
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          border: "2px solid #4FC3F7",
          zIndex: 2,
          display: { xs: "none", md: "block" },
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "40px",
          left: "100px",
          width: "15px",
          height: "15px",
          borderRadius: "50%",
          backgroundColor: "#00BFA5",
          zIndex: 2,
          display: { xs: "none", md: "block" },
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
        <Box sx={{ maxWidth: { xs: "100%", md: "55%" }, py: 4 }}>
          {/* Decorative line with dot */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <Box
              sx={{
                width: "60px",
                height: "4px",
                backgroundColor: "#4FC3F7",
                borderRadius: "2px",
                mr: 2,
              }}
            />
            <Box
              sx={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                backgroundColor: "#4FC3F7",
              }}
            />
          </Box>

          {/* Main Headline */}
          <Typography
            variant="h2"
            sx={{
              fontWeight: 900,
              fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
              lineHeight: { xs: 1.2, md: 1.1 },
              color: "#0D47A1",
              mb: 3,
            }}
          >
            Make Your “Go To” Team The A-Team!
          </Typography>

          {/* Description */}
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "1rem", md: "22px" },
              lineHeight: 1.7,
              color: "#424242",
              fontWeight: 600,
              mb: 4,
            }}
          >
            Staffing and project services for skilled professionals & the right talent across a range of specializations
          </Typography>

          {/* Buttons */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
          >
            <Button
              variant="contained"
              size="large"
              sx={{
                backgroundColor: "#1E88E5",
                color: "white",
                fontWeight: 700,
                px: { xs: 3, md: 4 },
                py: 1.5,
                fontSize: "17px",
                textTransform: "none",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: "#1565C0",
                },
              }}
              onClick={() => navigate("/staffing-services")}
            >
              Staffing Services
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={{
                color: "#1E88E5",
                borderColor: "#1E88E5",
                fontWeight: 700,
                px: { xs: 3, md: 4 },
                py: 1.5,
                fontSize: "17px",
                textTransform: "none",
                borderRadius: "4px",
                border: "2px solid #1E88E5",
                "&:hover": {
                  backgroundColor: "rgba(30, 136, 229, 0.04)",
                  borderColor: "#1565C0",
                },
              }}
              onClick={() => navigate("/services")}
            >
              Project Services
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Banner;